export const PATIENT_CDI_QUERY_ENDPOINT = `/arcplus/get-queries-list`;
export const PATIENT_STATUS_LIST_ENDPOINT = `/arcplus/get-status-list`;
export const PATIENT_TOPIC_LIST_ENDPOINT = `/arcplus/get-topic-list`;
export const VISITED_PATIENT_DETAIL_ENDPOINT = `/arcplus/get-query-details`;
export const QUERY_DETAIL_ANSWERS_ENDPOINT = "/arcplus/query-detail-answers";
export const UPDATE_QUERY_DETAIL_ENDPOINT = "arcplus/query-detail-answers";
export const GET_CONVERSATION_LIST_ENDPOINT = `/arcplus/conversation-list`;
export const GET_CONVERSATION_MESSAGE_LIST =
  "/arcplus/conversation-message-list";
export const POST_NEW_CONVERSATION = "/arcplus/create-new-conversation";
export const POST_NEW_MESSAGE = "/arcplus/create-conversation-message";
export const UPDATE_MESSAGE_READ_STATUS = "/arcplus/update-message-read-status";
export const UPDATE_CONVERSATION_STATUS = "arcplus/update-conversation-status";
export const PDF_QUERY_ENDPOINT = "arcplus/generate-query-pdf";
export const HTML_QUERY_ENDPOINT = "arcplus/generate-query-html";
export const GET_PROVIDER_DETAILS_ENDPOINT = "arcplus/get-provider-details";

// New dashboard and filter endpoints
export const GET_GRAPH_DATA_ENDPOINT = "/arcplus/get-graph-data";
export const GET_FACILITIES_LIST_ENDPOINT = "/arcplus/get-facilities-list";
export const GET_SPECIALTIES_LIST_ENDPOINT = "/arcplus/get-specialties-list";
export const GET_DATE_START_LIST_ENDPOINT = "/arcplus/get-date-start-list";
export const GET_DATE_END_LIST_ENDPOINT = "/arcplus/get-date-end-list";
export const FAVICON_CONST = "https://www.google.com/favicon.ico";

export const GET_VBC_ALERT_LIST = "/arcplus/v2/get-vbc-alerts";
export const UPDATE_VBC_ALERT_V2 = "/arcplus/v2/update-vbc-alert";
export const GET_CDI_ALERT_LIST = "/arcplus/get-cdi-alerts";
export const GET_CDI_ALERT_LIST_V2 = "/arcplus/v2/get-cdi-alerts";
export const UPDATE_CDI_ALERT_V2 = "/arcplus/v2/update-cdi-alert";
export const UPDATE_CDI_ALERT = "/arcplus/update-cdi-alert";
export const GET_ENCOUNTER_DRG_ENDPOINT = "/arcplus/encounter/drg";
export const GET_CARE_MANAGEMENT_QUERY_ENDPOINT =
  "/arcplus/care-management/queries";
export const GET_CLINICAL_CARE_GUIDELINES_ENDPOINT =
  "/arcplus/clinical-care-guidelines";
export const GET_CLINICAL_CARE_GUIDELINES_LOOKUP_ENDPOINT =
  "/arcplus/clinical-care-guidelines/lookup";
export const GET_CLINICAL_CARE_GUIDELINE_DETAIL_ENDPOINT = (id: string) =>
  `/arcplus/clinical-care-guidelines/${id}`;
export const GET_CLINICAL_CARE_GUIDELINE_REVISION_ENDPOINT = (
  id: string,
  revisionNumber: number | string
) => `/arcplus/clinical-care-guidelines/${id}/revisions/${revisionNumber}`;
export const DOCUMENT_REFERENCE_CREATION_ENDPOINT =
  "/arcplus/create-document-reference";

export const ENCODER_BASE_ENDPOINT = "/arcplus/emr/v1/encoder";
export const GET_ENCODER_CATALOG_ENDPOINT = ENCODER_BASE_ENDPOINT;
export const GET_ENCODER_CODES_SEARCH_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/codes/search`;
export const POST_ENCODER_CODES_INSTRUCTIONS_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/codes/instructions`;
export const POST_ENCODER_CODES_VALIDATE_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/codes/validate`;
export const POST_ENCODER_CODES_CPT_EDITS_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/codes/cpt-edits`;
export const GET_ENCODER_CM_EXPLORER_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/cm-explorer`;
export const GET_ENCODER_PCS_EXPLORER_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/pcs-explorer`;
export const GET_ENCODER_GUIDELINES_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/guidelines`;
export const GET_ENCODER_CLINICAL_CRITERIA_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/clinical-criteria`;
export const GET_ENCODER_MSDRG_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/msdrg`;
export const GET_ENCODER_COVERAGE_ENDPOINT = `${ENCODER_BASE_ENDPOINT}/coverage`;
